<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;"
        >课程中心</span
      >
      / 课程管理
    </div>
    <div class="class-management">
      <el-form size="small" :inline="true" ref="ruleForm" :model="ruleForm">
        <!--
        <el-form-item label="授课类型" prop="teaching_type">
          <el-select v-model="ruleForm.teaching_type" placeholder="请选择" style="width: 150px">
            <el-option label="全部" value=""></el-option>
            <el-option label="面授课" value="1"></el-option>
            <el-option label="直播课" value="2"></el-option>
            <el-option label="录播课" value="3"></el-option>
          </el-select>
        </el-form-item>
-->

        <el-form-item label="科目">
          <el-select
            v-model="ruleForm.subject_id"
            placeholder="请选择"
            filterable
            style="width: 150px"
            clearable
            @change="search"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) of subjectList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程类型">
          <el-select
            v-model="ruleForm.curriculum_type"
            placeholder="请选择"
            @change="search"
            clearable
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="体验课" value="1"></el-option>
            <el-option label="常规课" value="2"></el-option>
            <el-option label="短期课" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            @click="search"
            type="primary"
            v-if="$attrs.methodAuthTabView('查询')"
            >查询</el-button
          >
        </el-form-item>
      </el-form>

      <div>
        <el-table
          size="small"
          :data="curriculum_list"
          :header-cell-style="{
            background: '#f5f7fa',
            color: '#909399',
            'font-size': '14px',
          }"
          stripe
        >
          <el-table-column align="left" width="50" label="序号" fixed>
            <template slot-scope="scope">{{
              scope.$index + 1 + (page_no - 1) * page_size
            }}</template>
          </el-table-column>

          <el-table-column align="left" width="100" label="科目">
            <template slot-scope="scope">
              {{ scope.row.curriculumInfo.subjectName }}
            </template>
          </el-table-column>

          <el-table-column width="100" align="left" label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.curriculumInfo.curriculum_type == '1'"
                >体验课</span
              >
              <span v-else-if="scope.row.curriculumInfo.curriculum_type == '2'"
                >常规课</span
              >
              <span v-else-if="scope.row.curriculumInfo.curriculum_type == '3'"
                >短期课</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" width="50" label="封面">
            <template slot-scope="scope">
              <el-image
                style="width: 24px; height: 18px"
                :src="scope.row.curriculumInfo.img_url"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column width="200" align="left" label="课程名称">
            <template slot-scope="scope">
              <el-link
                type="primary"
                @click="
                  getPrepareCurrculumMaterialList(
                    scope.row.curriculumInfo.id,
                    scope.row.curriculumInfo.title
                  )
                "
                >{{ scope.row.curriculumInfo.title }}</el-link
              >
            </template>
          </el-table-column>

          <el-table-column align="left" label="课程简介">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.curriculumInfo.curriculum_desc"
                placement="top-start"
              >
                <span
                  style="
                        max-width: 150px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      "
                  >{{ scope.row.curriculumInfo.curriculum_desc }}</span
                >
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            align="center"
            prop="curriculumInfo.number_of_courses"
            label="节数"
            width="50"
          ></el-table-column>

          <el-table-column
            fixed="right"
            align="center"
            prop="price"
            width="100"
            label="价格(元)"
          ></el-table-column>
        </el-table>
      </div>
      <div class="pagination-style">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="page_no"
          layout="total, prev, pager, next"
          :page-size="page_size"
          :total="total"
        ></el-pagination>
      </div>

      <el-dialog
        :title="curriculum_title"
        :visible.sync="dialogVisible"
        width="80%"
      >
        <el-table
          :data="curriculumMaterialList"
          :header-cell-style="{ background: 'white' }"
          size="mini"
          height="500px"
        >
          <el-table-column width="100" align="left" label="序号">
            <template slot-scope="scope"> 第{{ scope.$index + 1 }}讲 </template>
          </el-table-column>

          <el-table-column align="left" width="200" label="封面">
            <template slot-scope="scope">
              <el-image
                style="width: 96px; height: 72px; border-radius: 5px"
                :src="scope.row.img_url"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="title"
            label="讲次名称"
            width="200"
          ></el-table-column>

          <el-table-column
            align="left"
            prop="desc"
            label="简介"
            :show-overflow-tooltip="true"
          ></el-table-column>

          <el-table-column width="100" align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="prepare(scope.row.id)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getCurriculumList,
  getCampusCurriculumtListByPage,
  getPrepareCurrculumMaterialList,
  getCampusSubjectList,
} from '@/api/educational'

export default {
  name: 'course-list',
  data() {
    return {
      //课程页码管理
      page_no: 1,
      page_size: 20,

      curriculum_title: '', //讲次名称
      dialogVisible: false, //讲次详情列表
      curriculumMaterialList: [], //讲次数据列表

      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,

      //搜索正式班级
      ruleForm: {
        subject_id: '',
        teaching_type: '',
        curriculum_type: '',
      },
      school_list: [],

      classStartTime: '',
      subjectList: [],
      tableData: [],
      curriculum_list: [],
      total: 0,

      //学员续班

      activeName: 'first', //正式学员列表

      current_class_id: '',
    }
  },
  mounted() {
    if (this.$store.state.user.selected_schools.length == 0) {
      this.$message.warning('请选择校区')
    } else {
      this.getCampusCurriculumtListByPage()
      this.ruleForm.subject_id = ''
      if (this.$store.state.user.selected_schools.length == 1) {
        this.getCampusSubjectList()
      }
    }
  },
  watch: {
    '$store.state.user.selected_schools': {
      handler(newValue) {
        console.log('校区监听')

        if (newValue.length == 0) {
          this.$message.warning('请选择校区')
        } else {
          this.getCampusCurriculumtListByPage()
        }

        if (newValue.length == 1) {
          this.getCampusSubjectList()
        } else {
          this.subjectList = []
          this.ruleForm.subject_id = ''
        }
      },
      deep: true,
    },
  },
  methods: {
    //获取学校科目权限列表
    getCampusSubjectList() {
      getCampusSubjectList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        this.subjectList = res.campusSubjectList
        console.log('获取学校科目权限列表')
        console.log(res)
      })
    },

    getCurriculumList(val) {
      this.ruleForm.curriculum_id = ''
      getCurriculumList({
        subject_id: val,
        page_size: 100,
      }).then((res) => {
        this.curriculum_list = res.curriculum_list
      })
    },
    search() {
      this.page_no = 1
      this.getCampusCurriculumtListByPage()
    },

    //获得讲次
    getPrepareCurrculumMaterialList(id, title) {
      getPrepareCurrculumMaterialList({
        curriculum_id: id,
      }).then((res) => {
        console.log('课程详情')
        console.log(res)
        this.curriculumMaterialList = res.curriculumMaterialList
        this.dialogVisible = true
        this.curriculum_title = title
      })
    },

    prepare(id) {
      this.$router.push({
        name: 'prepare',
        query: {
          curriculumMaterial_id: id,
          backname: 'course-list',
        },
      })
    },

    //获取学校公开课课程体系
    getCampusCurriculumtListByPage() {
      this.curriculum_list = []

      console.log('获取学校课程体系')
      console.log(this.ruleForm)

      getCampusCurriculumtListByPage({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        subjectId: this.ruleForm.subject_id,
        teaching_type: this.ruleForm.teaching_type,
        curriculum_type: this.ruleForm.curriculum_type,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('获取学校课程体系')
        console.log(res)
        this.curriculum_list = res.campusAuthList
        this.total = res.total
      })
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.getCampusCurriculumtListByPage()
    },
    reSize() {
      this.page_no = 1

      this.ruleForm = {
        subject_id: '',
        teaching_type: '',
        curriculum_type: '',
      }
      this.getCampusCurriculumtListByPage()
    },
  },
}
</script>

<style lang="scss" scoped>
.mainNew {
  height: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.class-management {
  min-height: calc(100% - 30px);

  padding: 20px;
  margin: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  background-color: #fff;

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
  }

  .setting {
    float: right;
  }
}
</style>
